import * as R from 'ramda';

import { Task, TaskUser } from '@atom/types/task';
import { getFieldPathById } from '@atom/utilities/workOrderFieldUtilities';

export const getTaskUser = (userId: string, task: Task): TaskUser => {
  const users = R.pathOr([], ['users'], task);
  return R.find(R.propEq(userId, 'id'))(users) as TaskUser;
};

const taskUserToUserDetail = users =>
  users.map(
    ({
      id,
      email,
      employeeId,
      firstName,
      lastName,
      photoUrl,
      status,
      title,
    }) => ({
      id,
      email,
      employeeId,
      firstName,
      lastName,
      photoUrl,
      status,
      title,
    }),
  );

const taskUserGroupToTemplateUserGroup = userGroups =>
  userGroups.map(
    ({ userGroupId, name, quantity, workTime, colorId, budget }) => ({
      userGroupId,
      name,
      quantity,
      workTime,
      colorId,
      budget,
    }),
  );

export const templateTaskToTask = tasks =>
  tasks.map(
    ({
      description,
      dueDate,
      duration,
      estimatedCost,
      fieldOrder,
      fields,
      id,
      isEstimatedCostOverridden,
      name,
      users,
      userGroups,
    }) => ({
      description,
      dueDate,
      duration,
      estimatedCost,
      fieldOrder,
      fields: [...fields],
      id,
      isEstimatedCostOverridden,
      name,
      users: taskUserToUserDetail(users),
      userGroups: taskUserGroupToTemplateUserGroup(userGroups),
    }),
  );

// Updates a value in a field on a task, taking care of nested fields.
export const updateFieldInTask = (task: Task, fieldId: string, value: any) => {
  // Get path to field (checking for nested fields).
  const nestedFieldPath = getFieldPathById(fieldId, task.fields);

  // Ramda.over() the path to set the new field's value,
  // returning the updated task.
  return R.over(R.lensPath(nestedFieldPath), nestedField => ({
    ...nestedField,
    value,
  }))(task);
};

export enum CustomFieldView {
  PREVIEW = 'PREVIEW',
  DETAIL = 'COMMENT',
  FILTER = 'FILTER',
}

export const DETAIL_FIELD_WIDTH = '30rem';
export const PREVIEW_FIELD_WIDTH = '19.5rem';
export const FILTER_FIELD_WIDTH = '15.75rem';

export const getTaskFieldWidth = (view: CustomFieldView): string => {
  switch (view) {
    case CustomFieldView.PREVIEW:
      return PREVIEW_FIELD_WIDTH;
    case CustomFieldView.DETAIL:
      return DETAIL_FIELD_WIDTH;
    case CustomFieldView.FILTER:
    default:
      return FILTER_FIELD_WIDTH;
  }
};
